import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setK3Scripts } from '../../actions';
import { getK3Docs } from '../../services/k3docService';
import {
  Modal,
  Form,
  Button,
  Row,
  Col
} from 'react-bootstrap';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import js from 'react-syntax-highlighter/dist/esm/languages/hljs/javascript';
import python from 'react-syntax-highlighter/dist/esm/languages/hljs/python';
import { tomorrow } from 'react-syntax-highlighter/dist/esm/styles/hljs';

// Register languages
SyntaxHighlighter.registerLanguage('javascript', js);
SyntaxHighlighter.registerLanguage('python', python);

class K3ScriptCreator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      script_mid: '',
      friendly_version: '',
      version_note: '',
      title: '',
      reason: '',
      description: '',
      language: '',
      script_code: '',
      author_type: '',
      execution_target: '',
      script_type: '',
      status: 'draft',
      tags: '',
      metadata: '{}',
      is_template: false,
      from_template_mid: '',
      configFields: null
    };
  }

  componentDidMount() {
    getK3Docs({ docMid: 'UI_CONFIG_FIELDS_K3SCRIPT' })
      .then(response => {
        const data = response.data.data.docs;
        if (data && data.length > 0 && data[0].content) {
          try {
            const configFields = JSON.parse(data[0].content);
            this.setState({ configFields });
          } catch (error) {
            console.error('Error parsing config fields:', error);
          }
        }
      })
      .catch(error => {
        console.error('Error fetching config fields:', error);
      });
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const scriptData = {
        ...this.state,
        tags: this.state.tags.split(',').map(tag => tag.trim()).filter(Boolean),
        metadata: JSON.parse(this.state.metadata)
      };
      await this.props.setK3Scripts([scriptData], { generate_version: true });
      this.props.onHide();
    } catch (error) {
      console.error('Error creating script:', error);
    }
  };

  render() {
    const { show, onHide } = this.props;
    const {
      script_mid,
      friendly_version,
      version_note,
      title,
      reason,
      description,
      language,
      script_code,
      author_type,
      execution_target,
      script_type,
      status,
      tags,
      metadata,
      is_template,
      from_template_mid,
      configFields
    } = this.state;

    return (
      <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Create New Script</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={this.handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Script MID</Form.Label>
                  <Form.Control
                    type="text"
                    name="script_mid"
                    value={script_mid}
                    onChange={this.handleChange}
                    required={true}
                    placeholder="Enter script MID"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    name="status"
                    value={status}
                    onChange={this.handleChange}
                  >
                    {configFields && configFields.status ? (
                      configFields.status.options.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))
                    ) : (
                      <>
                        <option value="draft">Draft</option>
                        <option value="final">Final</option>
                        <option value="test">Test</option>
                        <option value="deprecated">Deprecated</option>
                      </>
                    )}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>From Template</Form.Label>
                  <Form.Select
                    name="from_template_mid"
                    value={from_template_mid}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Template</option>
                    {this.props.scripts
                      .filter(s => s.is_template)
                      .map(s => (
                        <option key={s.script_mid} value={s.script_mid}>
                          {s.script_mid} - {s.title}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6} className="d-flex align-items-center">
                <Form.Group className="mb-3 w-100">
                  <Form.Label>Is Template</Form.Label>
                  <div>
                    <Form.Check
                      type="switch"
                      name="is_template"
                      checked={is_template}
                      onChange={(e) => this.handleChange({ target: { name: 'is_template', value: e.target.checked } })}
                      label="This is a template script"
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Version</Form.Label>
                  <Form.Control
                    type="text"
                    name="version"
                    value={''}
                    readOnly
                    placeholder=""
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Friendly Version</Form.Label>
                  <Form.Control
                    type="text"
                    name="friendly_version"
                    value={friendly_version}
                    onChange={this.handleChange}
                    placeholder="Optional"
                  />
                </Form.Group>
              </Col>
            </Row>

            {friendly_version && (
              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Version Note</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="version_note"
                      value={version_note}
                      onChange={this.handleChange}
                      rows={3}
                      placeholder="Enter version notes"
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Language</Form.Label>
                  <Form.Select
                    name="language"
                    value={language}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Language</option>
                    {configFields && configFields.language ? (
                      configFields.language.options.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))
                    ) : (
                      <>
                        <option value="javascript">JavaScript</option>
                        <option value="python">Python</option>
                        <option value="java">Java</option>
                        <option value="csharp">C#</option>
                      </>
                    )}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Execution Target</Form.Label>
                  <Form.Select
                    name="execution_target"
                    value={execution_target}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Target</option>
                    {configFields && configFields.execution_target ? (
                      configFields.execution_target.options.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))
                    ) : (
                      <>
                        <option value="human">Human</option>
                        <option value="ai">AI</option>
                        <option value="system">System</option>
                        <option value="tool">Tool</option>
                        <option value="web">Web</option>
                      </>
                    )}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Script Type</Form.Label>
                  <Form.Select
                    name="script_type"
                    value={script_type}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Type</option>
                    {configFields && configFields.script_type ? (
                      configFields.script_type.options.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))
                    ) : (
                      <>
                        <option value="script_runner">Script Runner</option>
                        <option value="web_agent_main_script">Web Agent Main Script</option>
                        <option value="web_agent_sub_script">Web Agent Sub Script</option>
                        <option value="general_script">General Script</option>
                        <option value="script_filter_k3doc">Script Filter K3Doc</option>
                      </>
                    )}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={title}
                onChange={this.handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Reason</Form.Label>
              <Form.Control
                as="textarea"
                name="reason"
                value={reason}
                onChange={this.handleChange}
                rows={3}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                name="description"
                value={description}
                onChange={this.handleChange}
                rows={3}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Script Code</Form.Label>
              <Form.Control
                as="textarea"
                name="script_code"
                value={script_code}
                onChange={this.handleChange}
                rows={10}
                required
                style={{ 
                  fontFamily: 'monospace',
                  fontSize: '0.875rem',
                  lineHeight: '1.5',
                  backgroundColor: '#1e1e1e',
                  color: '#ffffff',
                  border: '1px solid #3c3c3c'
                }}
              />
              {script_code && (
                <div className="mt-2" style={{ 
                  maxHeight: '300px', 
                  overflowY: 'auto',
                  backgroundColor: '#1e1e1e',
                  borderRadius: '0.25rem',
                  border: '1px solid #3c3c3c'
                }}>
                  <SyntaxHighlighter 
                    language={language || 'javascript'} 
                    style={tomorrow}
                    customStyle={{ 
                      margin: 0,
                      padding: '1rem',
                      fontSize: '0.875rem',
                      lineHeight: '1.5',
                      backgroundColor: '#1e1e1e',
                      color: '#ffffff'
                    }}
                    showLineNumbers
                    lineNumberStyle={{ color: '#858585' }}
                  >
                    {script_code}
                  </SyntaxHighlighter>
                </div>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Tags (comma-separated)</Form.Label>
              <Form.Control
                type="text"
                name="tags"
                value={tags}
                onChange={this.handleChange}
                placeholder="tag1, tag2, tag3"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Metadata (JSON)</Form.Label>
              <Form.Control
                as="textarea"
                name="metadata"
                value={metadata}
                onChange={this.handleChange}
                rows={3}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" onClick={this.handleSubmit}>
            Create
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  scripts: state.k3scriptReducer.scripts
});

export default connect(mapStateToProps, { setK3Scripts })(K3ScriptCreator);